module.exports = __webpack_public_path__ + "img/jk.7d6b4138.png";